import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getCurrentUserRole, MENU_CONFIG } from "../common/roleConfig";

const RouteGuard = ({
  component: Component,
  path,
  ...rest
}) => {
  const userRole = getCurrentUserRole();

  const checkPathAccess = (path) => {
    // Super admin has access to everything
    if (userRole === "-1") return true;

    // Check all menu items for the path
    const checkMenuSection = (items) => {
      return Object.values(items).some(item => {
        // Check if the current path is a sub-path of the menu item path
        if (item.path && path.startsWith(item.path)) {
          return item.roles?.includes(userRole);
        }
        // Check submenu items
        if (item.type === "submenu" && item.items) {
          return checkMenuSection(item.items);
        }
        // Check other nested items
        if (item.items) {
          return checkMenuSection(item.items);
        }
        return false;
      });
    };

    return checkMenuSection(MENU_CONFIG);
  };

  return (
    <Route
      {...rest}
      render={props => {
        // Redirect unauthenticated users to login
        const authUser = localStorage.getItem("authUser");
        if (!authUser) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }

        // Prevent redirect loops: allow dashboard to render even if access check fails
        const fallbackPath = "/admin/dashboard";
        const currentPath = props.location?.pathname;
        if (!checkPathAccess(path)) {
          // If user is authenticated but not authorized, do NOT send to login.
          // Keep them inside the app by redirecting to dashboard.
          if (path === fallbackPath || currentPath === fallbackPath) {
            return <Component {...props} />;
          }
          // Not authorized, redirect to dashboard as a safe fallback
          return (
            <Redirect
              to={{
                pathname: fallbackPath,
                state: { from: props.location }
              }}
            />
          );
        }

        // Authorized, render component
        return <Component {...props} />;
      }}
    />
  );
};

export default RouteGuard; 